
import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { Color } from './color.model';

@Injectable()
export class ColorResolver implements Resolve<Color> {
  constructor(
    protected router: Router,
    protected snackService: SnackService,
    protected backendService: BackendService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const id = route.params.id || 'agregar';

      if (id === 'agregar') {
        return this.backendService.new(Color);
      }
      return await this.backendService.get(Color, Color.path + id).toPromise();
    } catch (error) {
      this.router.navigate(['/colores']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/color/color.resolver.ts